import React, { Fragment } from 'react';
import { siteParams } from '../../config/site';
import IconAppleStore from '../../assets/images/icon-app-store.png';
import IconGooglePlay from '../../assets/images/icon-google-play.png';

const DownloadApp = () => (
  <Fragment>
    <h1 className="title-page">Baixe o Aplicativo</h1>

    <div className="row">
      <div className="col-md-6 mt-5 text-center">
        <h3 style={{ fontSize: '18px' }}>No seu iPhone</h3>
        <a href={siteParams.download.ios.store}>
          <img src={IconAppleStore} alt="" title="" height="55" />
        </a>
        <div>
          <a href={siteParams.download.ios.store}>{siteParams.download.ios.img}</a>
        </div>
        
        {(siteParams.name == "Bebanca" || siteParams.name == "Jornaleiro") && 
          <p>Baixe agora o aplicativo na App Store e leve jornais regionais e nacionais, para ler onde
          e quando quiser.</p>
        }

        {siteParams.name == "Begamer" && 
          <p>Revistas, notícias, vídeos, podcasts, promoções, fórum.</p>
        }

      </div>
      <div className="col-md-6 mt-5 text-center">
        <h3 style={{ fontSize: '18px' }}>No seu dispositivo Android</h3>
        <a href={siteParams.download.android.store}>
          <img src={IconGooglePlay} alt="" title="" height="55" />
        </a>
        <div>
          <a href={siteParams.download.android.store}>{siteParams.download.android.img}</a>
        </div>

        {(siteParams.name == "Bebanca" || siteParams.name == "Jornaleiro") && 
          <p>Desfrute de centenas de jornais no seu tablet ou smartphone Android. É só baixar o
          aplicativo no Google Play.</p>
        }

        {siteParams.name == "Begamer" && 
          <p>Tudo que rola no universo dos games, em um só lugar.</p>
        }

      </div>
    </div>

    
  </Fragment>
);

export default DownloadApp;



// WEBPACK FOOTER //
// ./src/pages/downloadApp/index.js